<template>
  <div>
    <div class="top-charts">
      <div class="chart">
        <div class="chart-title">
          市值 <span class="tips">{{ stockCapitalTips }}</span>
        </div>
        <chart ref="chartCapital" :opt="chartCapital"></chart>
      </div>
    </div>
    <hqtable
      ref="hqtable"
      class="table"
      v-bind:class="[type.key == 'stock' ? 'stock-table' : '']"
      :data="tdata"
      :fixed="fixed"
      :thead="thead"
      :sort.sync="sort"
      :tableWidth="tableWidth"
      :codeKey="codeKey"
      @on-row-click="rowClick"
      @on-th-click="target"
    >
      <div
        style="width: 100%;padding: 100px 0px;text-align: center;"
        slot="nodata"
      >
        {{ tableTips }}
      </div>
      <template v-slot:extend="extend">
        <div class="others">
          <div
            class="hq_tr"
            v-if="other"
            @click="clickOther(other, 999991)"
            v-bind:class="[selectedCode - 0 === 999991 ? 'hq_tr_active' : '']"
          >
            <div
              class="td_events td-word"
              :td-key="thead[0]['key']"
              :style="{ width: extend.widths[0] + 'px' }"
            >
              其他
            </div>
            <div
              class="td-word"
              :td-key="thead[1]['key']"
              :style="{ width: extend.widths[1] + 'px' }"
            >
              --
            </div>
            <div
                :td-key="thead[2]['key']"
                :style="{ width: extend.widths[2] + 'px' }"
              >
                {{ other.sixty_change ? Number(other.sixty_change * 100).toFixed(2) + '%' : "--" }}
              </div>
              <div
                :td-key="thead[3]['key']"
                :style="{ width: extend.widths[3] + 'px' }"
              >
                {{ other.hold_amount ? other.hold_amount : "--" }}
              </div>

            <div :style="{ width: extend.widths[4] + 'px' }">
              {{
                Number(other.share_market_capital / 100000000).toFixed(2)
              }}亿
            </div>
            <div :style="{ width: extend.widths[5] + 'px' }" :class="[other.market_capital_change > 0 ? 'red' : 'green']">
              {{ Number(other.market_capital_change / 100000000).toFixed(2) }}亿
            </div>
          </div>
          <div
            class="hq_tr no-border-bottom"
            v-if="total"
            @click="clickOther(total, 999992)"
            v-bind:class="[selectedCode - 0 === 999992 ? 'hq_tr_active' : '']"
          >
            <div
              class="td_events td-word"
              :td-key="thead[0]['key']"
              :style="{ width: extend.widths[0] + 'px' }"
              @dblclick="jumptoALl()"
            >
              合计
            </div>
            <div
              class="td-word"
              :td-key="thead[1]['key']"
              :style="{ width: extend.widths[1] + 'px' }"
              @dblclick="jumptoALl()"
            >
              {{ total[type.code_key] }}
            </div>
            <template v-if="type.name_key === 'name'">
              <div
                :td-key="thead[3]['key']"
                :style="{ width: extend.widths[2] + 'px' }"
              >
                <span
                  :class="[total.sixty_change ? (total.sixty_change > 0 ? 'red' : 'green') : '']"
                  >{{
                    total.sixty_change ? Number(total.sixty_change * 100).toFixed(2) + '%' : "--"
                  }}</span
                >
              </div>
              <div
                :td-key="thead[2]['key']"
                :style="{ width: extend.widths[3] + 'px' }"
              >
                <div>{{ total.hold_amount ? total.hold_amount : "--" }}</div>
              </div>
            </template>
            <template v-else>
              <div
                :td-key="thead[2]['key']"
                :style="{ width: extend.widths[2] + 'px' }"
              >
                <span
                  :class="[total.sixty_change > 0 ? 'red' : 'green']"
                  >{{
                    Number(total.sixty_change * 100).toFixed(2)
                  }}%</span
                >
              </div>
              <div
                :td-key="thead[3]['key']"
                :style="{ width: extend.widths[3] + 'px' }"
              >
                {{ total.hold_amount }}
              </div>
            </template>

            <div
              :td-key="thead[4]['key']"
              :style="{ width: extend.widths[4] + 'px' }"
            >
              {{
                Number(total.share_market_capital / 100000000).toFixed(2)
              }}亿
            </div>
            <div
              :td-key="thead[5]['key']"
              :style="{ width: extend.widths[5] + 'px' }"
              :class="[total.market_capital_change  ? total.market_capital_change > 0 ? 'red' : 'green' : '']"
            >
              {{ total.market_capital_change ? Number(total.market_capital_change / 100000000).toFixed(2) + "亿" : "--" }}
            </div>
          </div>
        </div>
      </template>
    </hqtable>

    <div class="bottom-chart">
      <div class="chart-title">
        “{{ selectName }}” {{ typename }}持股市值图
      </div>
      <chart ref="chartCompare" :opt="chartCompare"></chart>
    </div>
  </div>
</template>

<script>
import Chart from "../../lib/echarts-middleware";
import Hqtable from "../../lib/v-hqtable";

export default {
  name: "baseblock",
  props: ["type", "date", "resize", "color", "resizeType", "config"],
  components: {
    Chart,
    Hqtable
  },
  created() {
    this.optCapital.color = this.color.color;
    this.optInflow.color = this.color.color;
    this.optCapital.series[0].label.color = this.color.label;
    this.optInflow.series[0].label.color = this.color.label;
    this.optCapital.series[0].labelLine.lineStyle.color = this.color.labelLine;
    this.optInflow.series[0].labelLine.lineStyle.color = this.color.labelLine;
  },
  mounted() {
    this.checkStock();
    if (this.isNeedGetLocal()) {
      this.getDate();
    }
    window.addEventListener("resize", () => {
      this.$refs.hqtable && this.$refs.hqtable.resize();
    });
  },
  data() {
    return {
      // 表格的属性
      sort: { key: "share_market_capital", type: "down" },
      fixed: {
        thead: true,
        theadHeight: 30,
      },
      tableWidth: "840px",
      thead: [
        {
          key: 'name',
          name: this.type.name,
          class: ["t-head", "td-head", "td_name"],
          width: 80,
          events: {
            dblclick: (e, data) => {
              if (
                data[this.codeKey] &&
                data[this.codeKey] - 0 !== 999991 &&
                data[this.codeKey] - 0 !== 999992 &&
                data[this.codeKey] !== "--" &&
                data[this.codeKey] - 0 !== 999991
              ) {
                if (
                  this.type.type - 0 === 2 &&
                  this.type.name_key === "stock_name"
                ) {
                  let code = "HK" + data[this.codeKey];
                  API.use({
                    method: "Quote.switchPage",
                    data: {
                      id: "65",
                      code: code
                    }
                  });
                } else {
                  API.use({
                    method: "Quote.switchPage",
                    data: {
                      id: "65",
                      code: data[this.codeKey]
                    }
                  });
                }
                let type = this.type.type;
                let item = this.type.name_key;
                if (type - 0 === 1) {
                  if (item === "market_name") {
                    TA.log({
                      id: "cgpz_lgt_sctj_41",
                      _sid: "cgpz_lgt_sctj_41"
                    });
                  }
                  if (item === "index_name") {
                    TA.log({
                      id: "cgpz_lgt_zstj_41",
                      _sid: "cgpz_lgt_zstj_41"
                    });
                  }
                  if (item === "stock_name") {
                    TA.log({
                      id: "cgpz_lgt_zctj_41",
                      _sid: "cgpz_lgt_zctj_41"
                    });
                  }
                } else {
                  if (item === "market_name") {
                    TA.log({
                      id: "cgpz_ggt_sctj_41",
                      _sid: "cgpz_ggt_sctj_41"
                    });
                  }
                  if (item === "index_name") {
                    TA.log({
                      id: "cgpz_ggt_zstj_41",
                      _sid: "cgpz_ggt_zstj_41"
                    });
                  }
                  if (item === "stock_name") {
                    TA.log({
                      id: "cgpz_ggt_zctj_41",
                      _sid: "cgpz_ggt_zctj_41"
                    });
                  }
                }
              }
            }
          },
          format: function(v, tr) {
            let icon = "";
            if (!tr.isSub && tr.subset && tr.subset.length && tr.subState) {
              icon = "[-] ";
            } else if (
              !tr.isSub &&
              tr.subset &&
              tr.subset.length &&
              !tr.subState
            ) {
              icon = "[+] ";
            } else {
              icon = "";
            }
            return (
              '<div class="td-word txt-hide" title="' +
              v +
              '">' +
              icon +
              v +
              "</div>"
            );
          }
        },
        {
          key: 'code',
          name: "代码",
          class: ["t-head", "td-head", "td_code"],
          width: 60,
          events: {
            dblclick: (e, data) => {
              if (
                data[this.codeKey] &&
                data[this.codeKey] - 0 !== 999991 &&
                data[this.codeKey] - 0 !== 999992 &&
                data[this.codeKey] !== "--"
              ) {
                if (
                  this.type.type - 0 === 2 &&
                  this.type.name_key === "stock_name"
                ) {
                  let code = "HK" + data[this.codeKey];
                  API.use({
                    method: "Quote.switchPage",
                    data: {
                      id: "65",
                      code: code
                    }
                  });
                } else {
                  API.use({
                    method: "Quote.switchPage",
                    data: {
                      id: "65",
                      code: data[this.codeKey]
                    }
                  });
                }
              }
            }
          },
          format: function(v) {
            if (v.includes("1B")) return v.replace(/1B/, "00");
            return v ? v : "--";
          }
        },
        {
          key: "sixty_change",
          name: "60日涨幅",
          width: 90,
          sort: true,
          class: ["t-head", "td_week_price_change_ratio"],
          format: function(v) {
            let val = v ? Number(v).toFixed(2) + "%" : "--";
            if (val === "--") {
              return "--";
            }
            if (val - 0 === 0) {
              return "0.00";
            }
            if (v > 0) {
              return '<span class="red">' + val + "</span>";
            } else {
              return '<span class="green">' + val + "</span>";
            }
          }
        },
        {
          key: "hold_amount",
          name: "持股个数",
          width: 100,
          sort: true,
          class: ["t-head", "td_hold_amount"],
          format: function(v) {
            return v ? Number(v) : "--";
          }
        },
        {
          key: "share_market_capital",
          name: "持股市值",
          width: 120,
          sort: true,
          class: ["t-head", "td_share_market_capital"],
          format: function(v) {
            return v ? Number(v / 100000000).toFixed(2) + "亿" : "--";
          }
        },
        {
          key: "market_capital_change",
          name: "本季度市值增减",
          sort: true,
          width: 110,
          class: ["t-head", "td_week_share_market_capital"],
          format: function(v) {
            let val = String(v) ? Number(v / 100000000).toFixed(2) + "亿" : "--";
            if (val === "--") {
              return "--";
            }
            if (val - 0 === 0) {
              return "0.00";
            }
            if (v > 0) {
              return '<span class="red">' + val + "</span>";
            } else {
              return '<span class="green">' + val + "</span>";
            }
          }
        }
      ],
      codeKey: "code",
      tdata: [],
      // 图表配置
      // 实例
      getchart: false,
      chartCapital: {},
      chartInflow: {},
      chartCompare: {},
      allCapital: 0,
      allInflow: 0,
      // 配置
      optCapital: {
        animation: false,
        series: [
          {
            name: "市值",
            type: "pie",
            selectedOffset: 5,
            radius: ["50", "70"],
            center: ["50%", "50%"],
            data: "",
            label: {
              formatter: p => {
                return p.name + ':' + Number((p.value / this.total.share_market_capital) * 100).toFixed(2) + '%';
              }
            },
            labelLine: {
              lineStyle: {}
            },
            emphasis: {
              itemStyle: {
              }
            }
          }
        ]
      },
      optInflow: {
        animation: false,
        series: [
          {
            name: "流入金额",
            type: "pie",
            selectedOffset: 5,
            radius: ["50", "70"],
            center: ["50%", "50%"],
            data: "",
            label: {
              formatter: p => {
                if (this.type.name_key === "stock_name") {
                  return (
                    p.name +
                    ":" +
                    Number(
                      (p.value / this.total.accumulated_net_inflow) * 100
                    ).toFixed(2) +
                    "%"
                  );
                }
                return p.name + ":" + Number(p.percent).toFixed(2) + "%";
              }
            },
            labelLine: {
              lineStyle: {}
            },
            emphasis: {
              itemStyle: {
                // opacity: 0.5
                //     shadowBlur: 10,
                // shadowOffsetX: -5
                //     shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
            // itemStyle: {}
          }
        ]
      },
      optCompare: {
        animation: false,
        grid: {
          bottom: 100
        },
        color: ["#f8b551", "#e74741"],
        legend: {
          bottom: 50,
          itemWidth: 10,
          itemHeight: 10,
          data: [
            { name: "流入净额", icon: "rect" },
            { name: "持股市值", icon: "rect" }
          ],
          textStyle: {
            color: "#626262"
          }
        },
        dataZoom: [
          {
            type: "inside",
            start: 20,
            end: 100,
            zoomOnMouseWheel: false
          },
          {
            show: true,
            start: 20,
            end: 100,
            height: 25,
            dataBackgroundColor: "#363636"
          }
        ],
        xAxis: {
          type: "category",
          data: [],
          axisLine: {
            lineStyle: {
              color: "#626262"
            }
          },
          axisTick:{
              alignWithLabel:true
            },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          name: "金额(亿)",
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#626262"
            }
          },
          splitLine: {
            show: false
          },

          axisLabel: {
            formatter: value => {
              return parseInt(value / 100000000);
            },
            textStyle: {
              decoration: "none",
              align: "right"
            },
            interval: "auto",
            margin: 3
          }
        },
        tooltip: {
          trigger: "axis",

          axisPointer: {
            label: {
              show: false
            },
            crossStyle: {
              type: "solid"
            }
          },
          formatter: params => {
            this.tooltipTarget();
            let time = "时间：" + params[0].name + "<br/>";
            let result = "";
            for (let [index, value] of params.entries()) {
              result += `${value.seriesName}：${parseInt(
                params[index].value / 100000000
              )}亿<br/>`;
            }
            return time + result;
          }
        },
        series: [
          {
            data: [],
            type: "line",
            name: "流入净额",
            showSymbol: false,
            smooth: true
          },
          {
            data: [],
            type: "line",
            name: "持股市值",
            showSymbol: false,
            smooth: true
          }
        ]
      },
      // 整体配置
      datafault: false,
      // delay_time: 0,
      allDate: {},
      selectedCode: "",
      selectId:"",
      total: "",
      other: "",
      //埋点
      tooltipTargetFn: "",
      chartCompareDatazoomFn: "",
      chart1MouseoverFn: "",
      chart2MouseoverFn: ""
    };
  },
  methods: {
    isNeedGetLocal() {
      return (
        (this.type.key === "market" || this.type.key === "index") &&
        this.type.type === 1
      );
    },
    // 替换为新的表格接口
    getDate() {
      if (this.date) {
        return this.getLgtData();
      }
    },
    getLgtData() {   

      let url =
        `//apigate${process.env.NODE_ENV !== 'production' ? '-test' : ''}.10jqka.com.cn/d/hq/hshkconnect/block/holdconfiguration/v1/get_list`;
      $.ajax({
        type: "GET",
        url: url,
        data: {
          type: "north",
          timestamp: this.date,
          cate: this.type.key
        },
        dataType: "json",
        xhrFields: {
          withCredentials: true
        },
        success: res => {
          if(res.status_code !== 0 || !res.data){
            return;
          }
          const result = res.data.result.map(item => {
            if (!item.code) {
              return {
                ...item,
                code: item.id
              }
            }
            else {
              return item
            }
          })
          if (result && result.length) {
            this.setDateFun(result);
            this.changeSelected(true);
          } else {
            this.tdata = [];
            this.datafault = true;
          }
        },
        error: function(e) {
          console.log(e);
        }
      });
    },
    setDateFun(result) {
      // this.selectedCode = '';
      this.setTableDate(result);
      this.setChartDate();
      this.datafault = false;
    },
    getchartsInstance() {
      this.chartCapital = this.$refs["chartCapital"].chart;
      this.chartCompare = this.$refs["chartCompare"].chart;
      this.chartCapital.on("click", params => {
        if (params.componentType === "series") {
          let name = params.name;
          this.selectedCode = this.allDate[name][this.codeKey];
          this.selectId = this.allDate[name].id;
          let type = this.type.type;
          let item = this.type.name_key;
          if (type - 0 === 1) {
            if (item === "market_name") {
              TA.log({ id: "cgpz_lgt_sctj_30", _sid: "cgpz_lgt_sctj_30" });
            }
            if (item === "index_name") {
              TA.log({ id: "cgpz_lgt_zstj_30", _sid: "cgpz_lgt_zstj_30" });
            }
            if (item === "stock_name") {
              TA.log({ id: "cgpz_lgt_zctj_30_1", _sid: "cgpz_lgt_zctj_30_1" });
            }
          } else {
            if (item === "market_name") {
              TA.log({ id: "cgpz_ggt_sctj_30", _sid: "cgpz_ggt_sctj_30" });
            }
            if (item === "index_name") {
              TA.log({ id: "cgpz_ggt_zstj_30", _sid: "cgpz_ggt_zstj_30" });
            }
            if (item === "stock_name") {
              TA.log({ id: "cgpz_ggt_zctj_30_1", _sid: "cgpz_ggt_zctj_30_1" });
            }
          }
        }
      });
      this.chartCapital.on("mouseover", params => {
        if (
          params.componentType === "series" &&
          this.type.name_key == "stock_name"
        ) {
          if (this.chart1MouseoverFn) {
            this.chart1MouseoverFn();
          } else {
            this.chart1MouseoverFn = window.$util.util.throttle(
              this.chart1Mouseover,
              1000
            );
          }
        }
      });
      this.chartCompare.on("datazoom", () => {
        let type = this.type.type;
        let item = this.type.name_key;
        if (this.chartCompareDatazoomFn) {
          this.chartCompareDatazoomFn();
        } else {
          this.chartCompareDatazoomFn = window.$util.util.throttle(
            this.chartCompareDatazoom,
            1000
          );
        }
      });
      this.getchart = true;
    },
    // 获取新的分时数据
    getCompareDate(c) {
      let code = c || this.selectId;
      // 陆股通过去图表数据
      let url =
        `//apigate${process.env.NODE_ENV !== 'production' ? '-test' : ''}.10jqka.com.cn/d/hq/hshkconnect/block/holdconfiguration/v1/get_chart`;
      $.ajax({
        type: "GET",
        url: url,
        data: {
          type: "north",
          code: code,
          cate: this.type.key
        },
        dataType: "json",
        xhrFields: {
          withCredentials: true
        },
        success: response => {
          if (response.status_code !== 0 || !response.data) {
            return;
          }
          // 根据id判断是为了适配原来的逻辑
          const dataList = response.data.result || []
          this.setCompareDate(dataList);
        },
        error: function(e) {
          console.log(e);
        }
      });
    },
    setTableDate(d) {
      this.tdata = [];
      for (let i = 0; i < d.length; i++) {
        if (d[i].id === `sp_${this.type.key}_all`) {
          this.total = d[i];
        } else if (
          d[i].id ===  `sp_${this.type.key}_rest`
        ) {
          this.other = {
            ...d[i],
            code: 999991
          }
        } else {
          this.tdata.push(d[i]);
        }
      }
    },
    // 替换饼形数据
    setChartDate() {
      let data = this.tdata;
      let capital = [];
      let inflow = [];
      let name = [];
      this.allCapital = this.other.share_market_capital
        ? this.other.share_market_capital - 0
        : 0;
      this.allInflow = this.other.accumulated_net_inflow
        ? this.other.accumulated_net_inflow - 0
        : 0;
      this.allDate = {};
      for (let i = 0; i < data.length; i++) {
        if (data[i].share_market_capital) {
          let obj = {};
          obj.name = data[i].name;
          obj.value = data[i].share_market_capital;
          capital.push(obj);

          let oname = {};
          oname.icon = "circle";
          oname.name = obj.name;
          name.push(oname);
          this.allCapital += data[i].share_market_capital - 0;
        }
        if (data[i][this.codeKey]) {
          this.allDate[data[i][this.codeKey]] = data[i];
        }
        if (data[i][this.type.name_key]) {
          this.allDate[data[i][this.type.name_key]] = data[i];
        }
      }
      if(this.other && this.type.key === 'index'){
          capital.push({
            name:'其他',
            value: this.other.share_market_capital
          })
          this.allDate['999991'] = this.other;
          this.allDate['其他'] = this.other;
        }
      this.optCapital.series[0].data = capital;
      if (!this.getchart) {
        this.getchartsInstance();
      }
      if(this.tdata.length)
      this.getCompareDate(this.tdata[0].id);
      this.chartCapital.setOption(this.optCapital);
      // this.chartInflow.setOption(this.optInflow);
      if(this.tdata.length){
        this.selectedCode = this.tdata[0][this.codeKey];
        this.selectId = this.tdata[0].id;
      }
    },
    setCompareDate(d) {
      let time = [];
      let capital = [];
      // 替换新的图表数据源
      for (let i = 0; i < d.length; i++) {
        if(d[i].share_market_capital){
          let date = d[i].date.split("-").join("");
          time.push(date);
          capital.push(d[i].share_market_capital - 0);
        }
      }
      // 陆股通不需要流入净额
      this.optCompare.legend.data = [{ name: "持股市值", icon: "rect" }];
        this.optCompare.series = [
          {
            data: capital,
            type: "line",
            name: "持股市值",
            showSymbol: false,
            smooth: true
          }
        ];
      this.optCompare.xAxis.data = time;
      this.chartCompare.setOption(this.optCompare);
    },
    rowClick(e, data, target) {
      let code = data[this.codeKey];
      this.$refs.hqtable.setActiveIndex(code);
      this.selectedCode = code;
      this.selectId = data.id;
      let type = this.type.type;
      let item = this.type.name_key;
      if (type - 0 === 1) {
        if (item === "market_name") {
          TA.log({ id: "cgpz_lgt_sctj_40", _sid: "cgpz_lgt_sctj_40" });
        }
        if (item === "index_name") {
          TA.log({ id: "cgpz_lgt_zstj_40", _sid: "cgpz_lgt_zstj_40" });
        }
        if (item === "stock_name") {
          TA.log({ id: "cgpz_lgt_zctj_40", _sid: "cgpz_lgt_zctj_40" });
        }
      }
    },
    rechart(val) {
      if (!this.getchart) return;
      let w = 0;
      let w1 = 0;
      if (val < 1820) {
        w = (val - 148) / 2;
        w1 = val - 142;
      } else {
        w = (val - 148 - 8) / 4;
        w1 = (val - 142 - 5) / 2;
      }
      let opts = {
        width: w
      };
      let opts1 = {
        width: w1
      };

      this.chartCapital.resize(opts);
      this.chartCompare.resize(opts1);
      this.changeSelected(true);
      this.$refs.hqtable.setActiveIndex(this.selectedCode);
      this.$refs.hqtable.resize();
    },
    changeSelected(bol) {
      let val = this.selectedCode || 0;
      if (
         val - 0 === 999992 ||
        (val - 0 === 999991 && this.type.key !== "index")
      ) {
        this.getCompareDate();
        return;
      }
      if(!this.allDate[val]){
        return;
      }
      let currentName = this.allDate[val][this.type.name_key];
      this.chartCapital.dispatchAction({
        type: "pieSelect",
        name: currentName
      });
      if (!bol) {
        this.getCompareDate();
      }
      this.$refs.hqtable.setActiveIndex(val);
      if (val - 0 === 999991 && this.type.key === "index") {
        this.$refs.hqtable.setActiveIndex("--");
      }
    },
    checkStock() {
    },
    clickOther(total,code) {
      const { id } = total;  
      this.$refs.hqtable.setActiveIndex(code);
      this.selectedCode = code;
      this.selectId = id;
    },
    jumptoALl() {
      if (this.type.type === 1) {
        API.use({
          method: "Quote.switchPage",
          data: {
            id: "65",
            code: "120:000985"
          }
        });
      } else {
        API.use({
          method: "Quote.switchPage",
          data: {
            id: "65",
            code: "HSHKI"
          }
        });
      }
    },
    tooltipTarget() {
      let type = this.type.type;
      let item = this.type.name_key;
      clearTimeout(this.tipTimer);
      this.tipTimer = setTimeout(() => {
        if (type - 0 === 1) {
          if (item === "market_name") {
            TA.log({ id: "cgpz_lgt_sctj_50", _sid: "cgpz_lgt_sctj_50" });
          }
          if (item === "index_name") {
            TA.log({ id: "cgpz_lgt_zstj_50", _sid: "cgpz_lgt_zstj_50" });
          }
          if (item === "stock_name") {
            TA.log({ id: "cgpz_lgt_zctj_50", _sid: "cgpz_lgt_zctj_50" });
          }
        } else {
          if (item === "market_name") {
            TA.log({ id: "cgpz_ggt_sctj_50", _sid: "cgpz_ggt_sctj_50" });
          }
          if (item === "index_name") {
            TA.log({ id: "cgpz_ggt_zstj_50", _sid: "cgpz_ggt_zstj_50" });
          }
          if (item === "stock_name") {
            TA.log({ id: "cgpz_ggt_zctj_50", _sid: "cgpz_ggt_zctj50" });
          }
        }
      }, 800);
    },
    target(e) {
      if (e.sort) {
        let type = this.type.type;
        let item = this.type.name_key;
        if (type - 0 === 1) {
          if (item === "market_name") {
            TA.log({ id: "cgpz_lgt_sctj_42", _sid: "cgpz_lgt_sctj_42" });
          }
          if (item === "index_name") {
            TA.log({ id: "cgpz_lgt_zstj_42", _sid: "cgpz_lgt_zstj_42" });
          }
          if (item === "stock_name") {
            TA.log({ id: "cgpz_lgt_zctj_42", _sid: "cgpz_lgt_zctj_42" });
          }
          }
      }
    },
    chartCompareDatazoom() {
      let type = this.type.type;
      let item = this.type.name_key;
      if (type - 0 === 1) {
        if (item === "market_name") {
          TA.log({ id: "cgpz_lgt_sctj_51", _sid: "cgpz_lgt_sctj_51" });
        }
        if (item === "index_name") {
          TA.log({ id: "cgpz_lgt_zstj_51", _sid: "cgpz_lgt_zstj_51" });
        }
        if (item === "stock_name") {
          TA.log({ id: "cgpz_lgt_zctj_51", _sid: "cgpz_lgt_zctj_51" });
        }
      }
    },
    chart1Mouseover() {
      if (this.type.type - 0 === 1) {
        TA.log({ id: "cgpz_lgt_zctj_30_2", _sid: "cgpz_lgt_zctj_30_2" });
      } else {
        TA.log({ id: "cgpz_ggt_zctj_30_2", _sid: "cgpz_ggt_zctj_30_2" });
      }
    },
    chart2Mouseover() {
      if (this.type.type - 0 === 1) {
        TA.log({ id: "cgpz_lgt_zctj_31_2", _sid: "cgpz_lgt_zctj_31_2" });
      } else {
        TA.log({ id: "cgpz_ggt_zctj_31_2", _sid: "cgpz_ggt_zctj_31_2" });
      }
    }
  },
  computed: {
    selectName() {
      let name = "";
      if (
        this.selectedCode &&
        this.selectedCode - 0 !== 999991 &&
        this.selectedCode - 0 !== 999992
      ) {
        if(!this.allDate[this.selectedCode]){
          name = "";
          return;
        }
        name = this.allDate[this.selectedCode].name;
      } else if (this.selectedCode - 0 === 999991) {
        name = "其他";
      } else if (this.selectedCode - 0 === 999992) {
        name = "合计";
      }
      return name;
    },
    isLgt() {
      return this.type.typename === "陆股通";
    },
    typename() {
      return this.type.typename;
    },
    tableTips() {
      if (this.datafault) {
        return "网络开了小差，过会就回来";
      } else {
        return "数据飞速加载中...";
      }
    },
    stockCapitalTips() {
      if (
        this.type.key === "stock" &&
        this.tdata.length &&
        this.allCapital &&
        this.total.share_market_capital
      ) {
        let perc = Number(
          ((this.allCapital - this.other.share_market_capital) /
            ((this.total.share_market_capital) - 0)) *
            100
        ).toFixed(2);
        return isNaN(perc) ? "" : `前${this.tdata.length}只股票市值占比${perc}%`;
      }
    },
    stockInflowTips() {
      if (
        this.type.name_key === "stock_name" &&
        this.tdata.length &&
        this.allInflow &&
        this.total.accumulated_net_inflow
      ) {
        let perc = Number(
          ((this.allInflow - this.other.accumulated_net_inflow) /
            (this.total.accumulated_net_inflow - 0)) *
            100
        ).toFixed(2);
        return `前${this.tdata.length}只股票流入净额占比${perc}%`;
      }
    }
  },
  watch: {
    date: {
      handler(newval, oldval) {
        this.sort = { key: 'share_market_capital', type: 'down' };
        if (newval) {
          this.getDate();
        }
      }
    },
    resizeType(val) {
      if (val === this.type.key + this.type.type) {
        this.rechart(this.resize);
      }
    },
    selectedCode(val, old) {
      if (
        old &&
        (old - 0 !== 999991 || this.type.key === "index") &&
        old - 0 !== 999992
      ) {
        let oldName = this.allDate[old].name;
        this.chartCapital.dispatchAction({
          type: "pieUnSelect",
          name: oldName
        });
      }
      if (val === old || !val) return;
      this.changeSelected(!old);
    },
    color() {
      this.optCapital.color = this.color.color;
      this.optInflow.color = this.color.color;
      this.optCapital.series[0].label.color = this.color.label;
      this.optInflow.series[0].label.color = this.color.label;
      this.optCapital.series[0].labelLine.lineStyle.color = this.color.labelLine;
      this.optInflow.series[0].labelLine.lineStyle.color = this.color.labelLine;
    }
  }
};
</script>

<style scoped>
.top-charts {
  height: 300px;
  padding: 7px 0 10px;
  display: flex;
  flex-direction: row;
}
.divide {
  width: 1px;
  background-color: #22262b;
  height: 100%;
}
.chart {
  display: flex;
  justify-content: center;
  flex: 1;
  height: 300px;
  position: relative;
  margin: 0 1px;
  width: 100%;
}
.chart-title {
  position: absolute;
  font-size: 12px;
  padding-left: 5px;
  left: 10px;
  top: 3px;
}
.table {
  width: 100%;
  min-height: 200px;
  max-height: 400px;
  margin: 0 auto;
  font-size: 12px;
}
.stock-table {
  height: 400px;
}
.bottom-chart {
  height: 300px;
  position: relative;
  margin-top: 20px;
}
.others {
  display: table-row-group;
  vertical-algin: middle;
  border-color: inherit;
}
.table >>> div[thead-key="market_name"],
.table >>> div[td-key="market_name"],
.table >>> div[thead-key="index_name"],
.table >>> div[td-key="index_name"],
.table >>> div[thead-key="name"],
.table >>> div[td-key="name"],
.table >>> div[thead-key="market"] {
  text-align: left;
  padding-left: 5px;
}
.table >>> div[thead-key="market_code"],
.table >>> div[td-key="market_code"],
.table >>> div[thead-key="index_code"],
.table >>> div[td-key="index_code"],
.table >>> div[thead-key="code"],
.table >>> div[td-key="code"] {
  text-align: left;
}
.table >>> div[thead-key="market_capital_change"],
.table >>> div[td-key="market_capital_change"] {
  padding-right: 5px;
}
.table >>> .txt-hide {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table >>> div {
  width: 100%;
}
.table >>> .hq_container_theadfixed {
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/block/lgtblock.vue